import React from "react";
import { Link } from "react-router-dom";
import logoNotificameIcon from "../assets/Logo_circle.png";
import logoPlugmeIcon from "../assets/logo-plug.png";
import logoNotificameFull from "../assets/logo.png";
import logoPlugmeFull from "../assets/logoPluggMe.png";

export function getBrandLogoIconSrc() {
	return process.env.REACT_APP_NOME === "NotificaMe"
		? logoNotificameIcon
		: logoPlugmeIcon;
}

export function getBrandLogoFullSrc() {
	return process.env.REACT_APP_NOME === "NotificaMe"
		? logoNotificameFull
		: logoPlugmeFull;
}

function LogoSet({ logoSrc, alt }) {
	return (
		<>
			<div className="logo-light">
				<img
					src={logoSrc}
					alt={alt}
					className="logo-lg h-8 w-auto max-w-[140px] object-contain object-left"
				/>
				<img
					src={logoSrc}
					alt=""
					aria-hidden
					className="logo-sm h-8 w-auto max-w-[44px] object-contain"
				/>
			</div>
			<div className="logo-dark">
				<img
					src={logoSrc}
					alt={alt}
					className="logo-lg h-8 w-auto max-w-[140px] object-contain object-left"
				/>
				<img
					src={logoSrc}
					alt=""
					aria-hidden
					className="logo-sm h-8 w-auto max-w-[44px] object-contain"
				/>
			</div>
		</>
	);
}

export default function BrandLogo({ to = "/", onClick }) {
	const logoSrc = getBrandLogoIconSrc();
	const alt = process.env.REACT_APP_NOME || "Logo";

	return (
		<Link
			to={to}
			className="logo-box sticky top-0 z-10 box-border flex h-topbar-height min-h-topbar-height max-h-topbar-height shrink-0 items-center justify-start border-b border-default-200 px-6 backdrop-blur-sm dark:border-default-700"
			onClick={onClick}
		>
			<LogoSet logoSrc={logoSrc} alt={alt} />
		</Link>
	);
}
